export default function LoadingScreen() {
  return (
    <div className="vp-bg">
      <div className="vp-scene">
        <div className="vp-orb vp-orb-1" />
        <div className="vp-orb vp-orb-2" />
        <div className="vp-orb vp-orb-3" />
        <div className="vp-noise" />
      </div>
      <div className="vp-center">
        <div className="vp-panel">
          <div className="vp-loading">
            <div className="vp-loading-spinner" />
            <p className="vp-loading-text">Loading profile...</p>
          </div>
        </div>
      </div>
    </div>
  );
}
